export function normalizeJobSearchText(value) {
  const rawValue = Array.isArray(value) ? value[0] : value;
  return String(rawValue ?? "")
    .trim()
    .replace(/\s+/g, " ");
}

export function buildJobSearchQuery(freeTerm, location) {
  const query = {};
  const normalizedTerm = normalizeJobSearchText(freeTerm);
  const normalizedLocation = normalizeJobSearchText(location);

  if (normalizedTerm) query.free_term = normalizedTerm;
  if (normalizedLocation) query.location = normalizedLocation;

  return query;
}
